import axios from 'axios'
import wx from './wechat/wechat-param'
import router from '../router'

import ToastPlugin from 'vux/src/plugins/toast/index.js'

import Vue from 'vue'
import qs from 'qs'
import VConsole from 'vconsole'

Vue.prototype.$vux = ToastPlugin;


let upBaseUrl = '';
if (process.env.NODE_ENV === 'testing') {

upBaseUrl = 'https://sit-apitest.jrit.top';


}
if (process.env.NODE_ENV === 'production') {



upBaseUrl = 'https://shareapi.you-huo.com/';
}
if (process.env.NODE_ENV === 'development') {

upBaseUrl = 'https://sit-apitest.jrit.top';
}
const instance = axios.create({
baseURL: upBaseUrl,
timeout: 20000,
headers: {

"Content-Type": 'application/json',

},
})

instance.interceptors.request.use(
config => {




config.headers['token'] = window.localStorage.getItem('token')?window.localStorage.getItem('token'):'';
return config;
},
error => {
return Promise.reject(error);
}
);
instance.interceptors.response.use(function (response) {
if (response.data.code === 500) {
Vue.$vux.toast.show({
text: response.data.message,
type: 'text'
})
}
if (response.data.code === 400) {
Vue.$vux.toast.show({
text: response.data.message,
type: 'text'
})
}
return response
}, function (error) {


Vue.$vux.loading.hide()
Vue.$vux.toast.show({
text: error,
type: 'text'
})
return Promise.reject(error)

})

export {
instance,
upBaseUrl
}



// WEBPACK FOOTER //
// ./src/jslib/HttpRequest.js